// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.patientVoice_list__KDvav {
  margin: 0;
  padding: 0;
  list-style: none;
  display: grid;
  gap: var(--space-6) var(--space-6);
  grid-template-columns: minmax(0, 1fr);
}
.patientVoice_stat__KdwKp {
  padding-top: var(--space-5);
  border-top: 2px solid var(--kur-gold);
}
.patientVoice_value__KHMa8 {
  margin: 0 0 var(--space-3);
  font-size: clamp(3rem, 2rem + 3.5vw, 4.75rem);
  line-height: 1;
  font-weight: 500;
  letter-spacing: var(--tracking-figure);
  color: #fff;
  font-variant-numeric: tabular-nums;
}
.patientVoice_text__7pyXz {
  margin: 0;
  line-height: 1.55;
  color: var(--color-text-muted-on-dark);
}
.patientVoice_srOnly__O18wy {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
}
@media (min-width: 640px) {
  .patientVoice_list__KDvav {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (min-width: 1100px) {
  .patientVoice_list__KDvav {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}
`, "",{"version":3,"sources":["webpack://./src/PAGES/PHYSICIANS/SECTIONS/PATIENT_VOICE/patientVoice.module.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,kCAAkC;EAClC,qCAAqC;AACvC;AACA;EACE,2BAA2B;EAC3B,qCAAqC;AACvC;AACA;EACE,0BAA0B;EAC1B,6CAA6C;EAC7C,cAAc;EACd,gBAAgB;EAChB,sCAAsC;EACtC,WAAW;EACX,kCAAkC;AACpC;AACA;EACE,SAAS;EACT,iBAAiB;EACjB,sCAAsC;AACxC;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE;IACE,gDAAgD;EAClD;AACF;AACA;EACE;IACE,gDAAgD;EAClD;AACF","sourcesContent":[".list {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  display: grid;\n  gap: var(--space-6) var(--space-6);\n  grid-template-columns: minmax(0, 1fr);\n}\n.stat {\n  padding-top: var(--space-5);\n  border-top: 2px solid var(--kur-gold);\n}\n.value {\n  margin: 0 0 var(--space-3);\n  font-size: clamp(3rem, 2rem + 3.5vw, 4.75rem);\n  line-height: 1;\n  font-weight: 500;\n  letter-spacing: var(--tracking-figure);\n  color: #fff;\n  font-variant-numeric: tabular-nums;\n}\n.text {\n  margin: 0;\n  line-height: 1.55;\n  color: var(--color-text-muted-on-dark);\n}\n.srOnly {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  clip: rect(0 0 0 0);\n  white-space: nowrap;\n}\n@media (min-width: 640px) {\n  .list {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n@media (min-width: 1100px) {\n  .list {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": `patientVoice_list__KDvav`,
	"stat": `patientVoice_stat__KdwKp`,
	"value": `patientVoice_value__KHMa8`,
	"text": `patientVoice_text__7pyXz`,
	"srOnly": `patientVoice_srOnly__O18wy`
};
export default ___CSS_LOADER_EXPORT___;
